import { useEffect } from 'react';

export const THEME_PALETTES = {
  light: { background: '#f6f8fc', surface: '#ffffff', raised: '#f1f4f9', border: '#dce3ed', textPrimary: '#172033', textMuted: '#59677b', accent: '#a62d40', accentSoft: 'rgba(180, 69, 74, 0.10)' },
  dark: { background: '#0f1117', surface: '#181c25', raised: '#222836', border: '#343d4d', textPrimary: '#edf1f7', textMuted: '#a6b1c3', accent: '#f19aa7', accentSoft: 'rgba(225, 109, 131, 0.14)' },
};
export const normalizeTheme = (theme) => theme === 'light' ? 'light' : 'dark';
export const getWorkspaceTheme = () => normalizeTheme(localStorage.getItem('bloomquest-theme') || localStorage.getItem('bloomquest-admin-theme'));
export const getThemePalette = (theme) => THEME_PALETTES[normalizeTheme(theme)];

export function useWorkspaceTheme(theme, setTheme) {
  useEffect(() => {
    const root = document.documentElement;
    const previous = root.getAttribute('data-bq-theme');
    const value = normalizeTheme(theme);
    root.setAttribute('data-bq-theme', value);
    localStorage.setItem('bloomquest-theme', value);
    localStorage.setItem('bloomquest-admin-theme', value);
    return () => { if (previous === null) root.removeAttribute('data-bq-theme'); else root.setAttribute('data-bq-theme', previous); };
  }, [theme]);
  useEffect(() => {
    if (!setTheme) return undefined;
    const update = (event) => {
      if (event.type === 'storage' && !['bloomquest-theme', 'bloomquest-admin-theme'].includes(event.key)) return;
      setTheme(normalizeTheme(event.detail?.theme || (event.type === 'storage' ? event.newValue : localStorage.getItem('bloomquest-theme'))));
    };
    window.addEventListener('theme-updated', update);
    window.addEventListener('storage', update);
    return () => { window.removeEventListener('theme-updated', update); window.removeEventListener('storage', update); };
  }, [setTheme]);
}
